import { QUESTION_MEDIA_PATH_S3 } from 'constants/images'
import { AnswerInput, QuestionTypeEnum } from '__generatedTypes__/globalTypes'
import { prepareEditorHtml } from 'components/Editor'
import { FormState } from './consts'
import { getQuestionTypeConfig } from './questionTypeConfig'
import { serializeRxWritingAnswers } from './RxWritingAnswers/helpers'
import { serializeNumericResponseAnswer } from './NumericResponseAnswer/helpers'
import { serializeTextCompletionAnswers } from './TextCompletionAnswers/helpers'

export const prepareAnswers = async (values: Partial<FormState>, type: QuestionTypeEnum): Promise<AnswerInput[]> => {
  const config = getQuestionTypeConfig(type)

  if (config.answerMode === 'json') {
    switch (type) {
      case QuestionTypeEnum.RxWritingNDEB:
        return serializeRxWritingAnswers(values.rxWritingAnswer)
      case QuestionTypeEnum.TextCompletion:
        return serializeTextCompletionAnswers(values.textCompletionAnswer)
      case QuestionTypeEnum.NumericResponse:
        return serializeNumericResponseAnswer(values.numericResponseAnswer)
      default:
        return []
    }
  }

  const { hasPoints, optionInput } = config

  return Promise.all(
    values.answer?.map(async (answer, index) => {
      const rawText = answer.textAsHtml ?? ''
      const textAsHtml =
        optionInput === 'plain' ? rawText.trim() : await prepareEditorHtml(rawText, QUESTION_MEDIA_PATH_S3)

      return {
        id: answer.id,
        textAsHtml,
        isCorrect: answer.isCorrect,
        point: hasPoints ? (answer.isCorrect ? +(answer.point ?? 0) : -+(answer.point ?? 0)) : +answer.isCorrect,
        order: index,
      }
    }) ?? []
  )
}
